import State from '../interfaces/states/State';

import ProductById from '../interfaces/ProductById';

import { createSelector } from 'reselect';

export const currentProductId$ = (state: State): number => state.product.currentProductId;

export const productOrder$ = (state: State): number[] => state.product.productOrder;

export const productById$ = (state: State): Record<number, ProductById> => state.product.productById;

export const productsById$ = createSelector(
  productById$,
  productOrder$,
  (productById, productOrder)
    : ProductById[] => productOrder.map(id => productById[id])
);

export const currentProductName$ = createSelector(
  productsById$,
  currentProductId$,
  (productsById, currentProductId): string => productsById[currentProductId].name
);

export const currentProductLabel$ = createSelector(
  productsById$,
  currentProductId$,
  (productsById, currentProductId): string => productsById[currentProductId].label
);
